var _defs, _polygon, _path, _polygon2, _g, _path2, _polygon3, _path3, _path4, _circle, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuoy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "floating_buoy",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b72743;\n      }\n\n      .cls-2 {\n        fill: #d1d1d1;\n      }\n\n      .cls-3 {\n        fill: #969696;\n      }\n\n      .cls-4 {\n        fill: #d3354f;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "322.53 278.89 272.35 247.16 307.13 225.16 297.79 210.38 256 236.81 214.21 210.38 204.87 225.16 239.65 247.16 189.47 278.89 198.82 293.67 256 257.5 313.18 293.67 322.53 278.89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.63,95.22h-43.27v-29.79c0-11.95,9.69-21.63,21.63-21.63h0c11.95,0,21.63,9.69,21.63,21.63v29.79Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "339.3 333.29 284.71 116.91 267.83 121.17 267.83 116.42 244.17 116.42 244.17 121.17 227.29 116.91 172.7 333.29 195.63 339.08 244.17 146.66 244.17 339.58 267.83 339.58 267.83 146.66 316.37 339.08 339.3 333.29"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "203.88 306.37 179.49 306.37 172.7 333.29 195.63 339.08 203.88 306.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "316.37 339.08 339.3 333.29 332.51 306.37 308.12 306.37 316.37 339.08"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 244.17,
    y: 306.37,
    width: 23.65,
    height: 33.21
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.77,90.49h60.47c1.93,0,3.5,1.57,3.5,3.5v10.07h-67.46v-10.07c0-1.93,1.57-3.5,3.5-3.5Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "244.17 116.42 244.17 121.17 227.29 116.91 222.27 136.8 289.73 136.8 284.71 116.91 267.83 121.17 267.83 116.42 244.17 116.42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M249.41,62.48h13.18c2.89,0,5.24,2.35,5.24,5.24v88.91c0,2.89-2.35,5.24-5.24,5.24h-13.18c-2.89,0-5.24-2.35-5.24-5.24V67.72c0-2.89,2.35-5.24,5.24-5.24Z",
    transform: "translate(368.17 -143.83) rotate(90)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M256,430.23h0c-53.64,0-97.13-43.48-97.13-97.13v-12.71h194.25v12.71c0,53.64-43.49,97.13-97.13,97.13Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 250.22,
    cy: 61.6,
    r: 7.9,
    transform: "translate(95.71 267.84) rotate(-66.99)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.13,333.1v-12.71h-65.39c-5.79,23.04-28.02,73.02-111.45,68.17,17.55,25.18,46.7,41.67,79.72,41.67h0c53.64,0,97.13-43.48,97.13-97.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuoy);
export default __webpack_public_path__ + "static/media/Buoy.ef28ba98388ae188dc87e082c546b3ac.svg";
export { ForwardRef as ReactComponent };